/* CITIMI – product card photos: the main photo + up to 3 extra photos.
   Desktop: at rest the main photo. As soon as the cursor is on the card the extra photos follow it:
   left third = photo 2, middle third = photo 3, right third = photo 4 (with 1 or 2 extra photos the card
   is split into 1 or 2 parts). The slide timing (CSS) matches the reference video: 0.67 s, soft start and landing.
   A thin bar at the very bottom of the photo shows which extra photo is on. Leaving the card goes back to the main photo.
   Calm by design: a small dead zone at the borders between the parts, and the slider arrows lying on top of
   the edge cards do not count as "leaving the card".
   Touch screens: all photos can be swiped (CSS); the bar follows the finger.
   Extra photos are loaded as soon as a card comes near the screen, so nothing pops in during the slide.
   Works for cards added later (infinite scroll, related products, sliders).
   Also here: on phones the photo viewer that opens on a tap on a product photo shows the photos 4:5. */
(function () {
  var CARD = '[data-citimi-slides]';
  var OVERLAY = '.flickity-prev-next-button'; // slider arrows: full-height columns over the edge cards
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var active = null; // the card under the cursor

  /* ---------- show a photo: 0 = main photo, 1.. = extra photos ---------- */
  function show(card, index) {
    if (card._citimiIndex === index) return;
    card._citimiIndex = index;
    var track = card.querySelector('.citimi-slides__track');
    if (track) track.style.transform = index ? 'translate3d(' + (-100 * index) + '%, 0, 0)' : '';
    setBar(card, index);
    card.classList.toggle('is-citimi-active', index > 0);
  }

  // bar position, in parts: desktop counts the extra photos only (photo 2 = part 0), touch screens count all photos
  function setBar(card, index) {
    var bar = card.querySelector('.citimi-slides__bar');
    if (!bar) return;
    if (finePointer.matches && index === 0) return; // the bar fades out where it is
    bar.style.setProperty('--citimi-bar-pos', finePointer.matches ? Math.max(0, index - 1) : index);
  }

  function release(card) {
    if (!card) return;
    card._citimiZone = null;
    show(card, 0);
    if (active === card) active = null;
  }

  // the card under a screen point, also when an arrow button lies on top of it
  function cardAt(x, y) {
    var stack = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
    for (var k = 0; k < stack.length; k++) {
      var c = stack[k].closest && stack[k].closest(CARD);
      if (c) return c;
    }
    return null;
  }

  function cardFor(event) {
    var t = event.target;
    if (!t || !t.closest) return null;
    var card = t.closest(CARD);
    if (!card && t.closest(OVERLAY)) card = cardAt(event.clientX, event.clientY);
    return card;
  }

  /* ---------- desktop: extra photos follow the cursor ---------- */
  var pending = null;
  var frame = 0;

  function onMove(event) {
    if (!finePointer.matches || (event.pointerType && event.pointerType !== 'mouse')) return;
    pending = event;
    if (!frame) frame = window.requestAnimationFrame(applyMove);
  }

  function applyMove() {
    frame = 0;
    var event = pending;
    pending = null;
    if (!event) return;
    var card = cardFor(event);
    if (active && active !== card) release(active);
    if (!card) return;
    var extras = (parseInt(card.getAttribute('data-citimi-slides'), 10) || 1) - 1;
    if (extras < 1) return;
    var area = card.querySelector('.product_image') || card;
    var rect = area.getBoundingClientRect();
    if (!rect.width) return;
    active = card;
    var f = ((event.clientX - rect.left) / rect.width) * extras; // position in parts
    var zone = card._citimiZone;
    // dead zone: switch only once the cursor is clearly over the border (about 12px)
    var dead = Math.min(0.25, (12 / rect.width) * extras);
    if (zone == null || f < zone - dead || f > zone + 1 + dead) {
      zone = Math.max(0, Math.min(extras - 1, Math.floor(f)));
      card._citimiZone = zone;
    }
    loadExtras(card);
    show(card, zone + 1);
  }

  function onLeave(event) {
    if (!finePointer.matches || !event.target.closest) return;
    var card = event.target.closest(CARD);
    if (!card) return;
    var to = event.relatedTarget;
    if (to && card.contains(to)) return;
    // moving onto a slider arrow that lies on top of this same card is not leaving it
    if (to && to.closest && to.closest(OVERLAY) && cardAt(event.clientX, event.clientY) === card) return;
    release(card);
  }

  document.addEventListener('pointermove', onMove, { passive: true });
  document.addEventListener('pointerout', onLeave, { passive: true });
  // cursor leaves the browser window
  document.documentElement.addEventListener('mouseleave', function () { release(active); });

  /* ---------- touch screens: the bar follows the swipe ---------- */
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track.classList || !track.classList.contains('citimi-slides__track')) return;
    var card = track.closest(CARD);
    if (card) setBar(card, track.scrollLeft / Math.max(track.clientWidth, 1)); // follows the finger continuously
  }, true);

  /* ---------- desktop: load the extra photos before they are needed ---------- */
  function loadExtras(card) {
    if (card._citimiLoaded) return;
    card._citimiLoaded = true;
    var imgs = card.querySelectorAll('img.citimi-slides__extra');
    for (var k = 0; k < imgs.length; k++) {
      var img = imgs[k];
      if (!img.classList.contains('lazyload')) continue;
      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(img);
      } else if (img.getAttribute('data-src')) {
        if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.setAttribute('src', img.getAttribute('data-src'));
        img.classList.remove('lazyload');
        img.classList.add('lazyloaded');
      }
    }
  }

  // on touch screens the theme's lazy loading already brings in the next photos while swiping
  var observer = finePointer.matches && 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      loadExtras(entry.target);
    });
  }, { rootMargin: '300px 0px' }) : null;

  function watch(root) {
    if (!observer) return;
    var cards = root.querySelectorAll ? root.querySelectorAll(CARD) : [];
    for (var k = 0; k < cards.length; k++) {
      var card = cards[k];
      if (card._citimiWatched) continue;
      card._citimiWatched = true;
      observer.observe(card);
    }
  }

  /* ---------- phones: the photo viewer (tap on a product photo) shows the photos 4:5, like the gallery ---------- */
  var phone = window.matchMedia('(max-width: 798px)');
  var BOX_W = 800, BOX_H = 1000; // 4:5; the theme asks the viewer for 800 x 800 (square) boxes

  function hookLightbox() {
    var $ = window.jQuery;
    if (!$ || !$.fancybox || hookLightbox.done) return;
    hookLightbox.done = true;
    $(document).on('onInit.fb', function (event, instance) {
      var $box = instance && instance.$refs && instance.$refs.container;
      if (!phone.matches || !$box || !$box.hasClass('product-section__lightbox')) return;
      $box.addClass('citimi-lightbox');
      var bg = window.getComputedStyle(document.body).backgroundColor;
      if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') $box[0].style.setProperty('--citimi-page-bg', bg);
      // every photo gets a 4:5 box; CSS lets the photo fill it (object-fit: cover), cropped like in the gallery
      $.each(instance.group, function (k, item) {
        if (item.type === 'image' && item.opts) {
          item.opts.width = BOX_W;
          item.opts.height = BOX_H;
        }
      });
      // photos without a preview take their size from the file once loaded: keep 4:5 for them too
      var resolve = instance.resolveImageSlideSize;
      instance.resolveImageSlideSize = function (slide) {
        resolve.apply(this, arguments);
        if (slide && slide.type === 'image') {
          slide.width = BOX_W;
          slide.height = BOX_H;
        }
      };
    });
  }

  function init() {
    hookLightbox(); // jQuery and the viewer load with "defer" after this file, so this waits for DOMContentLoaded
    if (!observer) return;
    watch(document);
    // cards that arrive later: infinite scroll, related products, quick views
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        for (var r = 0; r < records.length; r++) {
          var added = records[r].addedNodes;
          for (var n = 0; n < added.length; n++) {
            var node = added[n];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches(CARD)) watch(node.parentNode || document);
            else if (node.querySelector && node.querySelector(CARD)) watch(node);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', hookLightbox); // in case the viewer arrived late
})();
